<div class="snack-bar"
     [ngClass]="{ 'small': size === snackSize.Small, 'large': size === snackSize.Large, 'open': size !== snackSize.Hidden && snacks.length, 'scroll': snacks.length > 6 }">
    @if (size === snackSize.Large && snacks.length) {
        <div class="toggle-container">
            <div class="snack-bar-toggle" (click)="hideSnackBar()" title="Close Snackbar">
                <i class="fa fa-chevron-up"></i>
            </div>
        </div>
    }
    @for (snack of snacks; track processIdTracker($index, snack)) {
        <snack [details]="snack"
            [size]="size"
            [signalRDisconnected]="signalRDisconnected">
        </snack>
    }
</div>
